import type { HTMLAttributes, PropsWithChildren } from 'react';

type CardProps = HTMLAttributes<HTMLDivElement> & {
    header?: string;
}

export function Card({ children, className = '', header, ...props }: PropsWithChildren<CardProps>) {
    return (
        <div className={`relative overflow-hidden rounded-3xl border border-white/70 bg-white/85 text-foreground shadow-lg backdrop-blur-xl animate-fade-up ${className}`} {...props}>
            <div className="absolute inset-0 bg-linear-to-br from-white/90 via-white/85 to-white/75" />
            <div className="relative space-y-4 p-6 md:p-8">
                {!!header && <h2 className="text-xl md:text-2xl font-semibold text-foreground">{header}</h2>}
                {children}
            </div>
        </div>
    );
}
